import Image from "next/image";
import { SelectorItem } from "./ProductVariantSelect";

type BookDisplayProps = Pick<SelectorItem, "title" | "subTitle" | "image">;

const BookDisplay = ({ title, subTitle, image }: BookDisplayProps) => {
  return (
    <div className="grid max-h-80 w-full gap-4 rounded-xl border bg-white px-4 py-2">
      <div className="flex items-center justify-between gap-3 text-black">
        <div className="flex gap-3">
          <div>
            {image?.src && (
              <Image
                src={image.src}
                height={70}
                width={70 * (image.aspectRatio ?? 4 / 3)}
                alt={image.alt}
              />
            )}
          </div>
          <span className="grid self-center text-left">
            <span className="font-semibold">{title}</span>
            <span className="text-sm text-gray-800">{subTitle ?? ""}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookDisplay;
